import helper from 'helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('sitePhotogallery');
export const actions = helper.createActions('sitePhotogallery', actionTypes);
